import { useState } from "react";
import { getStudyContent } from "../../../../../services/study.service";
import { StudyContentType } from "../../../../../types/welcome";

interface OnBoardingApiReturn {
  content: StudyContentType | null;
  loadContent: () => Promise<void>;
}

const useOnBoardingApi = (
  studyId: number,
  contentId: number | null,
  lang: string
): OnBoardingApiReturn => {
  const [content, setContent] = useState<StudyContentType | null>(null);

  const loadContent = async (): Promise<void> => {
    // No onboarding page configured for this study -> nothing to fetch.
    // (Fetching /contents/null 400s with "contentId must be a number".)
    if (typeof contentId !== "number") return;
    try {
      const { data } = await getStudyContent({ studyId, contentId, lang });
      setContent(data);
    } catch (e) {
      console.error(e);
    }
  };

  return {
    content,
    loadContent,
  };
};

export default useOnBoardingApi;
